module.exports = __webpack_public_path__ + "src/assets/img/contacts.8a0010f521fd4f3b90491c8fa4543226.svg";